import { Table } from 'react-bootstrap';
import ThemeSpinner from "./ThemeSpinner.js";

import React, { useEffect, useState } from "react";
import { GrDocumentUpdate } from "react-icons/gr";
import { useDispatch } from "react-redux";
import { EditIcon } from "../../configs/svg.js";

export default function CustomTable({
  header = [],
  data = [],
  classes = "",
  rowClass = "",
  loading,
  isAction = true,
  removeText = "",
  onEditClick = () => {},
  onRemoveClick = () => {},
  setModalData = {},
  setRemoveOpen,
  taskUpdate = false,
  setTaskModal,
  statusUpdate,
}) {
  const [activeSlug, setActiveSlug] = useState(null);
  const dispatch = useDispatch();

  const handleActionClick = (rowData) => {
    console.log(rowData);
    // dispatch(setSelectedData(rowData));
    // Toggle the active row by comparing the slug
    setActiveSlug((prevSlug) =>
      prevSlug === rowData?.id ? null : rowData?.id
    );
  };

  console.log(activeSlug);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [activeSlug]);

  const handleOutsideClick = (event) => {
    const Div = document.getElementById("view-dialogue");

    if (!Div?.contains(event.target)) {
      setActiveSlug(null);
    }
  };

  return (
    <div className={"tableContainer"}>
      {loading ? (
        <ThemeSpinner />
      ) : (
        <Table className={`${"Table"} ${classes}`}>
          <thead className={"thead"}>
            <tr className={"trh"}>
              {header?.map((item, index) => (
                <th key={index} className={"th"} style={item.style || {}}>
                  {item.title}
                </th>
              ))}
              {isAction && <th className={"th"}>Action</th>}
              {taskUpdate && <th className={"th"}>Action</th>}
            </tr>
          </thead>
          <tbody className={"tbody"}>
            {data?.length > 0 ? (
              data?.map((item, index) => {
                const isActive = activeSlug === item?.id; // Check if current row is active
                return (
                  <tr className={`${"trd"} ${rowClass}`} key={index}>
                    {header?.map((col, colIndex) => (
                      <td
                        key={colIndex} // Ensure unique key for each cell
                        className={`${"td"} ${col.elementClasses || ""}`}
                        style={col.elementStyle || {}}
                      >
                        {col?.render
                          ? col.render(item[col.dataIndex], item, index, data)
                          : item[col.dataIndex] || "-"}
                      </td>
                    ))}
                    {isAction && (
                      <td>
                        <div className="action-detail">
                          <div
                            className="btn btn-link"
                            onClick={() => handleActionClick(item)}
                          >
                            <EditIcon />
                          </div>
                          {isActive && (
                            <div className="options gap-2 d-flex flex-column align-items-start" id="view-dialogue">
                              <p
                                className="m-0 p-0 cursor"
                                onClick={() => {
                                  setModalData(item);
                                  onEditClick();
                                }}
                              >
                                {`Update ${removeText}`}
                              </p>
                              <p
                                className="m-0 p-0 remove cursor"
                                onClick={() => {
                                  setModalData(item);
                                  setRemoveOpen();
                                }}
                              >{`Remove ${removeText}`}</p>
                            </div>
                          )}
                        </div>
                      </td>
                    )}
                    {(taskUpdate && item?.status === 10)&& (
                      <td>
                        <div
                          className="action-detail"
                          title="Mark Complete Task"
                        >
                          <div
                            className="btn btn-link"
                            onClick={() => {
                              setTaskModal(true);
                              statusUpdate(item);
                            }}
                          >
                            <GrDocumentUpdate color="black" />
                          </div>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr className="empty-state">
                <td colSpan={header.length + (isAction ? 1 : 0) + (taskUpdate ? 1 : 0)}>
                  <p className="no-data-text">No Data Found</p>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </div>
  );
}
